var _circle, _path, _path2, _path3, _path4, _path5;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgIcCalendarCircle = function SvgIcCalendarCircle(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "currentColor",
    opacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9998 10.833C10.5396 10.833 10.1665 11.2061 10.1665 11.6663V19.6663C10.1665 20.1266 10.5396 20.4997 10.9998 20.4997H18.9998C19.4601 20.4997 19.8332 20.1266 19.8332 19.6663V11.6663C19.8332 11.2061 19.4601 10.833 18.9998 10.833H10.9998ZM9.1665 11.6663C9.1665 10.6538 9.98732 9.83301 10.9998 9.83301H18.9998C20.0124 9.83301 20.8332 10.6538 20.8332 11.6663V19.6663C20.8332 20.6789 20.0124 21.4997 18.9998 21.4997H10.9998C9.98732 21.4997 9.1665 20.6789 9.1665 19.6663V11.6663Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6665 8.5C17.9426 8.5 18.1665 8.72386 18.1665 9V11.6667C18.1665 11.9428 17.9426 12.1667 17.6665 12.1667C17.3904 12.1667 17.1665 11.9428 17.1665 11.6667V9C17.1665 8.72386 17.3904 8.5 17.6665 8.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.333 8.5C12.6092 8.5 12.833 8.72386 12.833 9V11.6667C12.833 11.9428 12.6092 12.1667 12.333 12.1667C12.0569 12.1667 11.833 11.9428 11.833 11.6667V9C11.833 8.72386 12.0569 8.5 12.333 8.5Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.1665 14.333C9.1665 14.0569 9.39036 13.833 9.6665 13.833H20.3332C20.6093 13.833 20.8332 14.0569 20.8332 14.333C20.8332 14.6092 20.6093 14.833 20.3332 14.833H9.6665C9.39036 14.833 9.1665 14.6092 9.1665 14.333Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.958 17C11.958 16.7929 12.1259 16.625 12.333 16.625H13.6663C13.8734 16.625 14.0413 16.7929 14.0413 17V18.3333C14.0413 18.5404 13.8734 18.7083 13.6663 18.7083H12.333C12.1259 18.7083 11.958 18.5404 11.958 18.3333V17ZM12.708 17.375V17.9583H13.2913V17.375H12.708Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcCalendarCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-calendar-circle.47cf8515.svg";
export { ForwardRef as ReactComponent };